import { useMutation } from '@tanstack/react-query';
import { updateUserPreferences } from '@/lib/api/settings/api';
import type { UserPreference } from '@/lib/api/settings/types';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

/**
 * Mutation hook for updating user communication preferences
 */
export function useUserPreferencesMutation() {
    return useMutation({
        mutationFn: (preferences: UserPreference[]) => updateUserPreferences(preferences),
        onSuccess: () => {
            // Refetch user data to get updated preferences
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });
}
